module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_feature_2-c1d545855e46e8efcbfe5f6563e2b494.svg";